<template>
  <v-container fluid class="pa-0 ma-0" >
<!-- <div id="page-top"></div> -->
    <!-- <router-link to="#page-top"> -->
      <!-- <v-btn fab dark  fixed right bottom small color="indigo"  @click="onTop()">
        <v-icon dark>keyboard_arrow_up</v-icon>
        
      </v-btn> -->
     <!-- </router-link>  -->

      <back-to-top  visibleOffset="400" text="TOP" style="opacity: .5; bottom: 20px; right: 5px; padding:10px; border-radius:50%; width:50px; height:50px; background-color:red;"></back-to-top>
      <!-- .vue-back-to-top {
    position: fixed;
    bottom: 40px;
    right: 30px; 
    width: 160px;
    color: #ffffff;
    text-align: center;
    line-height: 30px;
    background-color: #f5c85c;
    border-radius: 3px;
    z-index: 1000;
    cursor: pointer;
} -->
     
  
    
   
    <v-layout column align-center justify-center class="py-5" >
      <div class="page-title pt-3 amber--text" >TOURdeHDR+ AWARD 2017</div>
      <h4 class="shimmer ">My Favorite HDR Photos Taken At This Year  </h4>
    </v-layout>
    <v-layout row wrap  class="pb-4" justify-space-between >
      <v-flex v-for="award in awards" :key="award.id" d-flex> 
          <!-- <a v-bind:href="'#' + award.type"> -->
           <router-link :to="'#' + award.type">
            <v-btn class="award-btn" outline color="indigo">
            {{award.title}}
            </v-btn> 
           </router-link> 
          <!-- </a> -->
      </v-flex>
    </v-layout>

    <div v-for="award in awards" :key="award.id">
        <a v-bind:id="award.type"></a>
      <v-parallax  :src="award.imageUrl" width="100%" height="460" >
          <v-layout column align-center justify-center>
            <h4 class="title-image mx-2">AWARDS</h4>
            <h1 class="title-image mx-2 ">{{award.title}}</h1>
            <h4 class="title-image mx-2">{{award.subTitle}}</h4>

             <div class="text-xs-center">
                <v-btn round color="indigo" dark @click="onLoadMeetupAwards(award.type)">View More</v-btn>
              </div>

          </v-layout>
      </v-parallax>
      <section>
        <v-layout  row wrap   class="my-4" >
          <v-flex sx12 sm12 md6  lg6 offset-lg3  xl6  offset-xl3>
            <div  >
              <h3 class="title-image px-4 " >{{award.titleJp}}</h3>
              <p class="px-4 mt-1 ">{{award.subTitleJp}}</p>
              <!-- <p class="px-4 mt-1 ">{{award.type}}</p> -->

              <v-layout row wrap   class="my-4"  >
                <v-flex xs12 sm12 md6  lg6 xl6  
                        v-for="(meetup, index) in meetups" 
                        :key="meetup.id" 
                        v-if="award.type == meetup.type">
                    <span class=" mt-1"  @click="onLoadMeetupPost (meetup.id)"> <v-btn flat><v-icon>keyboard_arrow_right</v-icon>{{meetup.title}}</v-btn></span> 
                </v-flex>  
              </v-layout>
              <v-btn round color="indigo" dark class="ml-4" @click="onLoadMeetupAwards(award.type)">{{award.titleJp}}を見る</v-btn>
            </div>
          </v-flex>
        </v-layout>



          <!-- <v-layout row wrap   class="my-4">
            <v-flex   
                class="my-2"
                v-for="(meetup, index) in meetups" :key="meetup.id" v-if="award.type == meetup.type"
                style=" border:1px solid white; "
                > -->
                <!-- <div style=" width: 100%; padding:1rem;  margin: 1rem; border:1px solid white;"> -->

                   <!-- <v-layout row wrap   > -->
                      <!-- <v-flex xs1 sm1 md1  lg1  xl1  d-flex >
                        <h5 >{{index}}</h5>
                      </v-flex> -->
                      <!-- <v-flex   >
                        <v-card >
                          <v-card-media :src="meetup.imageUrl" height="300px"></v-card-media>
                          <v-card-title primary-title>
                            <div>
                              <h3 class="headline mb-0">Kangaroo Valley Safari</h3>
                              <div>Located two hours south of Sydney in the <br>Southern Highlands of New South Wales, ...</div>
                            </div>
                          </v-card-title>
                          <v-card-actions>
                            <v-btn flat color="orange">Share</v-btn>
                            <v-btn flat color="orange">Explore</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-flex> -->
                      <!-- <v-flex xs6 sm6 md7  lg7  xl7   d-flex >
                        <h5 >{{award.titleJp}}</h5>
                      </v-flex> -->
                  <!-- </v-layout> -->
                <!-- </div> -->
            <!-- </v-flex>
          </v-layout> -->

          <!-- <v-layout row wrap  align-center justify-center class="py-4" > -->
            <!-- <div v-for="(meetup, index) in meetups" :key="meetup.id" v-if="award.type == meetup.type">
              <v-flex  >
                <h5  class="title-image" >{{meetup.title}}</h5>
              </v-flex>
            </div> -->
              <!-- <v-flex sx12 sm8 md5  lg5  xl5 >
                <v-list light two-line>
                  <div v-for="(meetup, index) in meetups" :key="meetup.id" v-if="award.type == meetup.type">
                    <v-list-tile avatar  v-bind:key="meetup.id" @click="onLoadMeetupPost(meetup.id)">
                      <v-list-tile-avatar>
                        <img v-bind:src="meetup.imageUrl">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="meetup.title"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="meetup.subtitle"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </div>
                </v-list>
            </v-flex> -->
            <!-- <div v-for="(meetup, index) in meetups" :key="meetup.id" v-if="award.type == meetup.type"> -->

              <!-- <v-flex xs12 sm12 md6  lg4  xl4 offset-xl3  align-content-center 
                     v-for="(meetup, index) in meetups" :key="meetup.id" v-if="award.type == meetup.type" > -->
               
                <!-- <div style=" border:1px solid white;" d-flex> -->
                   <!-- <img :src="meetup.imageUrl" width="160" height="auto"></img> -->
                  <!-- <h6 class="title-image ">{{meetup.title}}</h6>
                  <h6 class="title-image ">{{meetup.subTitle}}</h6>
                  <h6 class="title-image ">{{award.location}}</h6>
                  <h6 class="title-image ">{{award.location}}</h6> -->
              
              <!-- </v-flex> -->

            <!-- </div> -->
            
            <!-- <v-flex xs12 sm6 md3  lg3  xl3  align-content-center>
              <div style=" width: 100%; padding:1rem; height: 7rem; border:1px solid white;">
                <h3 class="title-image ">{{award.titleJp}}</h3>
              </div>
            </v-flex> -->
            
          <!-- </v-layout> -->

          <!-- </v-layout> -->
      </section>
    </div>
  </v-container >
</template>

<script>
export default {
    data () {
    return {
      awards: [
          {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0208b1x1.jpg',
            id:1, 
            title:'BEST TITLE', 
            titleJp:'タイトル部門', 
            subTitle:'Select the best title image from all the stages', 
            subTitleJp:'２０１７年に投稿した１１ステージのタイトル画像から最も気に入っているデザインを選びました。', 
            type:'awStage'
            },
            {imageUrl: ' http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0259.jpg',
            id:2, 
            title:'BEST STAGE', 
            titleJp:'ベストステージ部門', 
            subTitle:'Select the best post image from all the stages', 
            subTitleJp:'各ステージの中から一番のお気に入りを選びました。', 
            type:'awPost'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2931.jpg',
            id:3, 
            title:'BEST DAYTIME', 
            titleJp:'デイタイム部門', 
            subTitle:'Select the best Daytime image from all the stages', 
            subTitleJp:'昼間のシーンからお気に入りを選びました。', 
            type:'awDaytime'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/b_road_panorama1b.jpg',
            id:4, 
            title:'BEST TWILIGHT', 
            titleJp:'トワイライト部門', 
            subTitle:'Select the best twilight image from all the stages', 
            subTitleJp:'夕暮れのシーンからお気に入りを選びました。', 
            type:'awTwilite'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img9665.jpg',
            id:5, 
            title:'BEST NIGHT', 
            titleJp:'ナイト部門', 
            subTitle:'Select the best night image from all the stages', 
            subTitleJp:'夜景の中からお気に入りを選びました。', 
            type:'awNight'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',
            id:6, 
            title:'BEST VEHICLE', 
            titleJp:'ビークル部門', 
            subTitle:'Select the best vehicle image from all the stages', 
            subTitleJp:'車、船など乗り物の画像から一番のお気に入りを選びました。', 
            type:'awVehicle'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/img1875base.jpg',
            id:7, 
            title:'BEST COMPOSIT', 
            titleJp:'合成部門', 
            subTitle:'Select the best composit image from all the stages', 
            subTitleJp:'３Dモデルの画像合成、アニメーション画像から一番のお気に入りを選びました。', 
            type:'awComposit'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img0749a1x1.jpg',
            id:8, 
            title:'BEST HDR', 
            titleJp:'ＨＤＲ部門', 
            subTitle:'Select the best HDR image from all the stages', 
            subTitleJp:'すべてのＨＤＲ画像から一番のお気に入りを選びました。', 
            type:'awHdr'
            }
      ]
    }
  },
  

  computed: {
      meetups () {
        return this.$store.getters.featuredMeetups
      },
      loading () {
        return this.$store.getters.loading
      }
    },
  methods: {
    onLoadMeetupPost (id) {
      //  console.log('top onLoadMeetupPost id ' + id)
      // this.$router.push('/title/' + id)
      this.$router.push('/entry/' + id)
    },
    onLoadMeetupAwards (id) {
      //  console.log('top onLoadMeetupAwards Type ' + id)
      // this.$router.push('/title/' + id)
      this.$router.push('/best/' + id + '#top')
      // this.$router.push('/thumnail/' + id)
    },
    onTop () {
      //  console.log('top onLoadMeetupAwards Type ' + id)
      // this.$router.push('/title/' + id)
      this.$router.push( '/#page-top')
      // this.$router.push('/thumnail/' + id)
    },
    
  }
 
}
</script>


<style scoped>


.card-block{
  background-color: black !important;
  border: solid 1px whitesmoke;
  opacity: .8;
}


.carusel-style{
  height:500px;
  box-shadow: none;
}
.img-style{
  width:100%;
 height:auto;
}
.image-inner{
  width:100%;
  height:100%;
}
.award-btn{
 width: 10rem;
}

.title-image {
  color: white;
  text-shadow: 0 5px 5px rgba(0, 0, 0, .8);
  /* font-family: "Arial Rounded MT Bold", "Helvetica Rounded", Arial, sans-serif; */
}
/* .milky {
  font-family: "Arial Rounded MT Bold", "Helvetica Rounded", Arial, sans-serif;;
  text-transform: uppercase;
  display: block;
  font-size: 92px;
  color: #f1ebe5;
  text-shadow: 0 8px 9px #c4b59d, 0px -2px 1px #fff;
  font-weight: bold;
  letter-spacing: -4px;
  text-align: center;
  background: linear-gradient(to bottom, #ece4d9 0%,#e9dfd1 100%);
  position: absolute;
  padding: 100px 200px;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  border-radius: 20px;
} */

/* text effect */
.shimmer {
  font-family: "Lato";
  font-weight: 300;
  font-size: 2em;
  margin: 0 auto;
  padding: 0 140px 0 140px;
  display: inline;
  margin-bottom: 0;
}
/* p {
  font-family: "Lato";
  font-weight: 300;
  font-size: 1em;
  color: rgba(255,255,255,0.65);
  width: 500px;
  text-align: justify;
  line-height: 1.5em;
  border-top: 1px dashed rgba(255,255,255,0.2);
  margin: 10px 0 0 5px;
  padding-top: 10px;
}
p a {
  text-decoration: none;
  color: #fff;
}
p a:visted {
  color: #fff;
} */
.shimmer {
  text-align: center;
  color: rgba(255,255,255,0.1);
  background: -webkit-gradient(linear, left top, right top, from(#222), to(#222), color-stop(0.5, #fff));
  background: -moz-gradient(linear, left top, right top, from(#222), to(#222), color-stop(0.5, #fff));
  background: gradient(linear, left top, right top, from(#222), to(#222), color-stop(0.5, #fff));
  -webkit-background-size: 125px 100%;
  -moz-background-size: 125px 100%;
  background-size: 125px 100%;
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  -webkit-animation-name: shimmer;
  -moz-animation-name: shimmer;
  animation-name: shimmer;
  -webkit-animation-duration: 4s;
  -moz-animation-duration: 4s;
  animation-duration: 4s;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-color: #222;
}
@-moz-keyframes shimmer {
  0% {
    background-position: top left;
  }
  100% {
    background-position: top right;
  }
}
@-webkit-keyframes shimmer {
  0% {
    background-position: top left;
  }
  100% {
    background-position: top right;
  }
}
@-o-keyframes shimmer {
  0% {
    background-position: top left;
  }
  100% {
    background-position: top right;
  }
}
@keyframes shimmer {
  0% {
    background-position: top left;
  }
  100% {
    background-position: top right;
  }
}


 .page-title {
    /* font-size: 112px; */
    font-size: 7em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 16px;
    color:white;
    padding: 0 140px 0 140px;
}



/* responsive  :::::::::::::::::::::::::::::::::::::::::::::::::::::::*/
@media only screen and (max-width: 600px){
  .carusel-style{
    height:360px;
  }
  .page-title {
   font-size: 3em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 16px;
    color:red;
    padding: 0 2rem 0 2rem;
  }
  .shimmer {
  /* font-family: "Lato"; */
  font-weight: 300;
  font-size: 1.8em;
  margin: 0 0;
  padding: 0 2rem 0 2rem;
  display: inline;
  margin-bottom: 0;
}


  
}
@media only screen and (min-width: 599px) and (max-width: 959px){
  .carusel-style{
    height:360px;
  }
  .page-title {
   font-size: 7em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 16px;
    color:white;
    padding: 0 140px 0 140px;
  }
  .shimmer {
  /* font-family: "Lato"; */
  font-weight: 400;
  font-size: 2em;
  margin: 0 auto;
  padding: 0 140px 0 140px;
  display: inline;
  margin-bottom: 0;
}
}
/* ms */
@media only screen and (min-width: 960px) and (max-width: 1264px){
  
}
@media only screen and (min-width: 1265px) and (max-width: 1904px){
  .carusel-style{
    height:580px;
  }
}

@media only screen and (min-width: 1905px) {
  .carusel-style{
    height:800px;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/top.vue